import { useGetChatsByShareId } from '@/hooks/useGetChatsByShareId';
import { observer } from 'mobx-react';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import { useParams } from 'react-router-dom';

const ChatItem = ({ item }: { item: any }) => {
    return (
        <div className="flex flex-col gap-[20px] max-md:gap-[15px]">
            <div
                className={`px-[20px] max-md:px-[15px] py-[10px] max-md:py-[8px] text-[12px] max-md:text-[11px] rounded-[16px] border ${
                    item.role === 'master'
                        ? 'bg-black text-white border-black ml-auto'
                        : 'bg-white border-primary/10'
                }`}
            >
                <ReactMarkdown>{item.content}</ReactMarkdown>
            </div>
            {item.type === 'adventure_reward' && !!item.image && (
                <div className="flex gap-[20px] text-[12px] max-md:gap-[15px]">
                    <img
                        src={item.image}
                        className="w-[200px] h-[200px] rounded-[32px] max-md:w-[150px] max-md:h-[150px] max-sm:rounded-[24px]"
                    />
                </div>
            )}
        </div>
    );
};

const Play: React.FC = observer(() => {
    const params: any = useParams();
    const { chats } = useGetChatsByShareId(params.id);

    return (
        <div className="flex flex-col gap-[20px] max-md:gap-[15px] w-full pb-[160px] px-[80px] mt-[80px]">
            {chats.map((item) => (
                <ChatItem key={item.id} item={item} />
            ))}
        </div>
    );
});

export default Play;
